/**
 * Pre-compiled en messages for DatePicker
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  "Time.enterTime": `Enter time`,
  "Time.enterTimeHour": `Enter time (hour)`,
  "Time.enterTimeHourMinute": `Enter time (hour and minute)`,
  "Time.enterTimeHourMinuteSecond": `Enter time (hour, minute, and second)`,
  "Time.startTime": `Start time`,
  clearInput: `Clear input value`,
};
